module.exports = __webpack_public_path__ + "img/login__background.bd661b7a.svg";